import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Revelr from 'configs';
import { Client } from 'api';
import Form from 'form';
import CardSelector from 'components/leads/cardSelector';
import { Button } from 'components/forms';

const FIELD_MAP = {
    'card[name]': 'name',
    'number': 'card_number',
    'card[cvc]': 'cvc',
    'card[exp_month]': 'exp_month',
    'card[exp_year]': 'exp_year',
    // These are dupes but I've seen both in responses from Stripe.
    // @TODO - @steves To investigate this further
    'exp_month': 'exp_month',
    'exp_year': 'exp_year',
};

const CARD_FORM_FIELDS = {
    card_number: {
        label: 'Card Number',
        validators: ['required'],
    },
    name: {
        label: 'Name on Card',
        validators: ['required'],
    },
    cvc: {
        label: 'CVC',
        validators: ['required', 'numeric'],
    },
    exp_month: {
        label: 'Expiration Month',
        validators: ['required', 'month'],
    },
    exp_year: {
        label: 'Expiration Year',
        validators: ['required', 'year'],
    },
};

export default class extends React.Component {
    static propTypes = {
        eventId: React.PropTypes.number.isRequired,
        onPaymentSuccess: React.PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.api = new Client();
        this.form = new Form(CARD_FORM_FIELDS);

        this.state = {
            cards: [],
            error: '',
            errors: {},
            newCard: {},
            show: true,
            saving: false,
            success: false,
            cardToken: null,
            cardsLoaded: false,
            selectedPlan: null,
            cardSelected: 'new',
        };
    }

    componentWillMount() {
        if (typeof Stripe === 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://js.stripe.com/v2/';
            script.async = 1;
            script.onload = () => {
                Stripe.setPublishableKey(Revelr.stripe_key);
            };

            document.body.appendChild(script);
        }

        this.api.request('/api/user/cards', {
            method: 'GET',
            success: (data) => {
                this.setState({
                    cards: data,
                    cardsLoaded: true,
                    newCardOpen: !data.length,
                    cardSelected: data.length > 0 ? data[0].id : 'new',
                });
            },
        });
    }

    handleCardFormChanged = (selected, data) => {
        this.setState({
            cardToken: null,
            cardSelected: selected,
            newCard: selected === 'new' ? data : {},
        });
    };

    submitForm = (e) => {
        e.preventDefault();
        this.setState({ saving: true });

        if (this.state.cardSelected !== 'new') {
            this.submitPayment();
            return;
        }

        const errors = this.form.validate(this.state.newCard);
        if (errors !== true) {
            this.setState({
                saving: false,
                errors: errors,
            });

            return;
        }

        Stripe.createToken({
            name: this.state.newCard.name,
            number: this.state.newCard.card_number,
            cvc: this.state.newCard.cvc,
            exp_month: this.state.newCard.exp_month,
            exp_year: this.state.newCard.exp_year,
        }, (status, response) => {
            if (response.error) {
                const error = {};
                error[FIELD_MAP[response.error.param]] = response.error.message;

                this.setState({ saving: false, errors: error }, () => {
                    this.tracker.logMessage('Credits payment failure', { response: response });
                });

                return;
            }

            this.setState({ cardToken: response.id, errors: {} }, () => {
                this.submitPayment();
            });
        });
    };

    submitPayment() {
        const data = { plan: this.state.selectedPlan };
        if (this.state.cardToken) {
            data.stripe_token = this.state.cardToken;
        } else {
            data.card = this.state.cardSelected;
        }

        this.api.request(`/api/events/${this.props.eventId}/pay/`, {
            data: data,
            method: 'POST',
            success: (response) => {
                if (response.error) {
                    this.setState({ saving: false, errors: { card_number: response.error } });
                } else {
                    this.props.onPaymentSuccess();
                }
            },
        });
    }

    render() {
        return (
            <div>
                <Modal show={this.state.show} dialogClassName="revelr-modal">
                    <div className="progress-container" />

                    <Modal.Header>
                        <span className="modal-title">Almost there</span>
                    </Modal.Header>

                    <form onSubmit={this.submitForm}>
                        <div className="modal-body">
                            <p>
                                On-demand venue concierge for <strong>$25</strong>.
                            </p>

                            <p>
                                Let us find the perfect venue within 14 days or your money back.
                            </p>

                            <p>
                                No kickbacks. No commissions. We're here to help you find the best venue for the best value.
                            </p>

                            <CardSelector
                                cards={this.state.cards}
                                errors={this.state.errors}
                                onFormChanged={this.handleCardFormChanged}
                            />
                        </div>

                        <div className="modal-footer">
                            <Button
                                onClick={this.submitForm}
                                saving={this.state.saving}
                                actionLabel="Saving"
                                submitLabel="Pay Now"
                            />
                        </div>
                    </form>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/EventPaymentModal.jsx